<template>
  <div class="modal-mask" v-on:scroll="scrollMove($el)">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column">
        <div ref="surveyHeader">
          <view-header :surveyData="surveyData"></view-header>
          
        </div>
        <div class="flex-grow-1">
          <view-tab @setViewTab="setViewTab"></view-tab>

          <div class="banner" v-if="campaignData && campaignData.image">
            <a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
              <img :src="campaignData.image" alt="" />
            </a>
            <a v-else href="javascript:void(0)" style="cursor:none">
              <img :src="campaignData.image" alt="" v-if="campaignData.image" />
            </a>
          </div>

          <div :class="setTabFixed && isAction ? 'mgt-50 mgb-60' : ''" v-if="headerType== false">
            <component
              :is="tabType"
              :surveyData="surveyData"
              :badgesData="badgesData"
            ></component>
          </div>
          <div v-if="headerType== true">
            <insight-view :surveyData="surveyData"></insight-view>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
/**
 * 단독 설문 상세 메인 컴포넌트(independent survey view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import ViewHeader from "./view/Header";
import ViewHeaderInsight from "./view/InsightHeader";
import ViewTab from "./view/ViewTab";
import ViewInformation from "./view/Information";
import ViewReward from "./view/Reward";
import { surveyMixin } from "@/mixins/survey.js";
import InsightViewVue from './InsightView.vue';

export default {
  name: "surveyTotalView",
  data() {
    return {
      surveyData: null,
      badgesData: null,
      tabType: "Information",
      campaignData: null,
      setTabFixed: false,
      headerType : false
    };
  },
  components: {
    "view-header": ViewHeader,
    "view-header-insight": ViewHeaderInsight,
    "view-tab": ViewTab,
    Information: ViewInformation,
    Reward: ViewReward,
    'insight-view': InsightViewVue,
  },

  mixins: [surveyMixin],
  watch:{
    $route (to, from){ 
        if(this.$route.query.listType == 'result'){
          if(this.$route.query.viewDetail == 'insightViewDetail'){
            this.headerType = false
          } else {
            this.headerType = true
          }
        } else {
          this.headerType = false
        }
    }
  },
  
  mounted() {
    if(this.$route.query.listType == 'result'){
      if(this.$route.query.viewDetail == 'insightViewDetail'){
            this.headerType = false
        } else {
          this.headerType = true
      }
    } else {
      this.headerType = false
    }
    this.fatchData();
  },

  methods: {
    setViewTab(tabType) {
      this.tabType = tabType;
    },

    // 상세 데이터 호출(get survey information data)
    async fatchData() {
      let params = {
        distId: this.$route.params.distId,
      };

      // check auth & get survey information data
      let authStatus = await this.checkLogin();
      if (authStatus && this.$route.query.distributionType != "SATISFACTION") {
        if(this.$route.query.listType == 'result') {
          let params1 = {
            distributionId: this.$route.params.distId,
          };
          surveyApi.surveyInsightView(params1).then((response) => {
            this.surveyData = response.data.data;
            //console.log('this.surveyData=>',this.surveyData)
          });
        } else {
          surveyApi.surveyIndependentView(params).then((response) => {
            this.surveyData = response.data.data;
          });
        }
        
      } else {
          if (this.$route.query.distributionType != "SATISFACTION") {
            if(this.$route.query.listType == 'result') {
            surveyApi.surveyInsightView(params).then((response) => {
              this.surveyData = response.data.data;
              //console.log('this.surveyData=>',this.surveyData)
            });
          } else {
            surveyApi.guestSurveyIndependentView(params).then((response) => {
              this.surveyData = response.data.data;
            });
          }  
        }
      }

      // get survey badges list
      if (this.$route.query.distributionType != "SATISFACTION") {
        surveyApi.guestSurveyIndependentViewBadges(params).then((response) => {
          this.badgesData = response.data.data;
        });
      }

      // get survey campaign data
      campaignApi
        .campaign({
          locationType: "IN_INDEPENDENT_SURVEY",
          locationValue: this.$route.params.distId,
        })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
    scrollMove(el) {
      if (
        parseInt(el.scrollTop) >= parseInt(this.$refs.surveyHeader.offsetHeight)
      ) {
        this.setTabFixed = true;
      } else {
        this.setTabFixed = false;
      }
    },
  },
};
</script>